import { type MutationOptions, useMutation } from 'react-query'

import agent from 'agent'
import useAuth from 'hooks/use-auth'
import { getEndpointWithParams } from 'queries/queries-utils'
import { sharedAssetsMutationKeys } from 'queries/sharedAssets/query-keys'

import type { AxiosError } from 'axios'
import type {
  SharedAssetsRequestsPayload,
  SharedAssetsRequestsPostResponse
} from 'types/api/sharedAssets/requests'

function postSharedAssetsRequest([endpoint, params]: ReturnType<
  typeof sharedAssetsMutationKeys.postSharedAssetsRequests
>) {
  return async (payload: SharedAssetsRequestsPayload) => {
    const endpointWithParams = getEndpointWithParams(endpoint, params)

    const response = await agent.post<SharedAssetsRequestsPostResponse>(
      endpointWithParams,
      payload
    )

    return response.data
  }
}

export const usePostSharedAssetsRequests = (
  options?: Omit<
    MutationOptions<
      SharedAssetsRequestsPostResponse,
      AxiosError,
      SharedAssetsRequestsPayload
    >,
    'mutationKey' | 'mutationFn'
  > & {
    owningTeamId?: string
  }
) => {
  const { currentTeamId } = useAuth()

  const { owningTeamId, ...queryOptions } = options ?? {}

  const teamId = owningTeamId ?? currentTeamId

  const queryParams = { teamId }

  const mutationKey =
    sharedAssetsMutationKeys.postSharedAssetsRequests(queryParams)

  return useMutation({
    ...queryOptions,
    mutationKey,
    mutationFn: postSharedAssetsRequest(mutationKey)
  })
}
